import { render, staticRenderFns } from "./FeatureColorSelection.vue?vue&type=template&id=5a22528a&scoped=true&"
import script from "./FeatureColorSelection.vue?vue&type=script&lang=js&"
export * from "./FeatureColorSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a22528a",
  null
  
)

export default component.exports